import React from 'react';
import ReactDOM from 'react-dom/client'; // Importa createRoot
import App from './App';
import './index.css'; // Se hai uno stile globale

// Trova l'elemento root nel DOM
const rootElement = document.getElementById('root');

// Crea il root con React 18
const root = ReactDOM.createRoot(rootElement);

// Renderizza l'app
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);